module.exports = __webpack_public_path__ + "img/H3.809c08d4.png";